import { useParams, useSearchParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useUser, useUserContext } from '../../../../context/UserProvider'
import { fetchCarByAccountNo, fetchFleetReportExpense } from '../../../../api/api'
import { ExcelExportButton } from '../components/ExcelExporter'
import FleetReportExpenseTable from '../components/FleetReportExpenseTable'
import type { FleetReportExpense as FleetReportExpenseType, Car } from '../../../../types'
import { excelFleetReportExpenseColumns } from '../components/FleetReportExpenseTable/excelUtils'
import AccountInfo from '../components/FleetReportDetailsTable/AccountInfo'

const FleetReportExpense = () => {
  const [searchParams] = useSearchParams()
  const type = searchParams.get('type') || 'month'
  const { account, itemNo } = useParams<{ account: string; itemNo: string }>()

  const user = useUser()
  const { chosenCompany: company, fleetReportTerm: term } = useUserContext() as any

  const companyId = company?.id
  const contactId = user?.user?.id

  const { data: car } = useQuery(
    ['carByAccountNo', contactId, companyId, account],
    () => fetchCarByAccountNo(contactId, companyId, account),
    { enabled: !!contactId && !!companyId && !!account },
  ) as { data: Car }

  const { data: reportResponse } = useQuery(
    ['fleetReportExpense', companyId, account, itemNo, term, type],
    () =>
      fetchFleetReportExpense({
        companyId,
        account,
        itemNo,
        term,
        type,
      }),
    { enabled: !!companyId && !!account && !!itemNo && !!term },
  )

  const reportData =
    //@ts-expect-error axios type issue
    (Array.isArray(reportResponse) ? reportResponse : reportResponse?.data || []) as FleetReportExpenseType[]

  const year = new Date(term).getFullYear()
  const month = new Date(term).getMonth() + 1

  const columns = excelFleetReportExpenseColumns()
  const config = {
    columns,
    filename: `Flåteutgifter_${account}_${itemNo}_${type === 'year' ? year : month}.xlsx`,
    sheetName: `Flåteutgifter_${account}`,
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4">
        <div className="flex flex-row justify-between items-center">
          <div className="flex flex-col gap-2">
            <span className="text-xl font-medium text-primaryText">Flåteutgifter</span>
            <AccountInfo car={car} />
          </div>
          <div className="md:hidden">
            <ExcelExportButton data={reportData} config={config} />
          </div>
        </div>
        <div className="flex flex-row gap-2 w-full md:w-auto md:self-end">
          <div className="hidden md:block">
            <ExcelExportButton data={reportData} config={config} />
          </div>
        </div>
      </div>
      <FleetReportExpenseTable data={reportData} />
    </div>
  )
}

export default FleetReportExpense
